<template>
  <div class="header-back">
    <div class="header-item header-item-size" style="width: 30%">
      <div v-if="isIcon">
        <div v-if="imageUrl">
          <router-link to="/mypage">
            <div style="position: relative">
              <img :src="imageUrl" />
              <span
                v-if="infoCount > 0"
                style="
                  position: absolute;
                  border-radius: 4.5px;
                  height: 9px;
                  min-width: 0;
                  padding: 0;
                  width: 9px;
                  background: red;
                  left: 28px;
                "
              ></span>
            </div>
          </router-link>
        </div>
        <div v-else>
          <router-link to="/mypage">
            <div style="position: relative">
              <img :src="require('@/assets/icon_user.webp')" />
              <span
                v-if="infoCount > 0"
                style="
                  position: absolute;
                  border-radius: 4.5px;
                  height: 9px;
                  min-width: 0;
                  padding: 0;
                  width: 9px;
                  background: red;
                  left: 28px;
                "
              ></span>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="isBack" style="color: #fff">
        <a @click="$router.go(-1)" style="cursor: pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
            />
          </svg>
        </a>
      </div>
      <div v-if="actionsType == 'modalUser'" style="color: #fff">
        <a @click="headerActionClick('modalUser')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
            />
          </svg>
        </a>
      </div>
      <div v-if="actionsType == 'modalUserByWithdrawal'" style="color: #fff">
        <a @click="headerActionClick('modalUser')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
            />
          </svg>
        </a>
      </div>
      <div v-if="actionsType == 'modalUserTimeline'" style="color: #fff">
        <a @click="headerActionClick('modalUserTimeline')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
            />
          </svg>
        </a>
      </div>
    </div>
    <div class="text-center header-item" style="padding-top: 5px; width: 40%">
      <span v-if="pageTitle == ''" class="title cherry-bomb-one-regular"
        >Kinkyer</span
      >
      <span
        v-else-if="pageTitle == 'subscription'"
        class="title cherry-bomb-one-regular"
        >Kinkyer+</span
      >
      <div
        v-else
        class="title m-plus-regular"
        style="font-size: 20px; padding-top: 10px"
      >
        {{ pageTitle }}
      </div>
    </div>
    <div
      class="header-item header-item-size"
      style="width: 30%"
      v-if="user.isEntry"
    >
      <div
        v-if="actionsType == 'skip_icon'"
        class="text-end"
        style="
          color: #fff;
          margin-right: 10px;
          font-size: 15px;
          font-weight: 700;
          margin-top: 5px;
        "
      >
        <a @click="headerActionClick('skip_icon')">スキップ</a>
      </div>
      <div
        v-if="actionsType == 'person'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('person')">
          <span class="material-symbols-rounded" style="font-size: 35px">
            account_circle
          </span>
        </a>
      </div>
      <div
        v-if="actionsType == 'event'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('event_today')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M360-300q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-40q0-17 11.5-28.5T280-880q17 0 28.5 11.5T320-840v40h320v-40q0-17 11.5-28.5T680-880q17 0 28.5 11.5T720-840v40h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"
            />
          </svg>
        </a>
        &nbsp;
        <router-link to="/mypage/event/list">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M433-80q-27 0-46.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-53 40q1 7 1 13.5v27q0 6.5-2 13.5l53 40q21 17 27 43t-8 49l-48 82q-14 23-39 32t-50-2l-60-26q-11 8-23 15t-24 12l-9 66q-4 26-23.5 44T527-80h-94Zm7-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z"
            />
          </svg>
        </router-link>
        <!-- &nbsp;
        <a @click="headerActionClick('event')">
          <span class="material-symbols-rounded" style="font-size: 35px">
            confirmation_number
          </span>
        </a> -->
      </div>
      <div
        v-if="actionsType == 'timeline-view'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('timeline-view')">
          <span class="material-symbols-rounded" style="font-size: 35px">
            tag
          </span>
        </a>
      </div>
      <div
        v-if="actionsType == 'matching'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('matching')"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M380-320q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l224 224q11 11 11 28t-11 28q-11 11-28 11t-28-11L532-372q-30 24-69 38t-83 14Zm0-80q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"
            />
          </svg>
        </a>
      </div>
      <div
        v-if="actionsType == 'groupChat'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('groupChat')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
            />
          </svg>
        </a>
      </div>
      <div
        v-if="actionsType == 'userDetail'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('userDetail-timeline')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M680-80H280q-33 0-56.5-23.5T200-160v-640q0-33 23.5-56.5T280-880h400q33 0 56.5 23.5T760-800v640q0 33-23.5 56.5T680-80Zm0-80v-640H280v640h400ZM480-600q33 0 56.5-23.5T560-680q0-33-23.5-56.5T480-760q-33 0-56.5 23.5T400-680q0 33 23.5 56.5T480-600Zm0 400q66 0 113-47t47-113q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47Zm0-80q-33 0-56.5-23.5T400-360q0-33 23.5-56.5T480-440q33 0 56.5 23.5T560-360q0 33-23.5 56.5T480-280ZM280-800v640-640Z"
            />
          </svg>
        </a>
        &nbsp;
        <a @click="headerActionClick('userDetail-sheet')"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
            />
          </svg>
        </a>
      </div>
      <div
        v-if="actionsType == 'modalUser'"
        class="text-end"
        style="color: #fff; margin-right: 5px"
      >
        <a @click="headerActionClick('userDetail-timeline')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M680-80H280q-33 0-56.5-23.5T200-160v-640q0-33 23.5-56.5T280-880h400q33 0 56.5 23.5T760-800v640q0 33-23.5 56.5T680-80Zm0-80v-640H280v640h400ZM480-600q33 0 56.5-23.5T560-680q0-33-23.5-56.5T480-760q-33 0-56.5 23.5T400-680q0 33 23.5 56.5T480-600Zm0 400q66 0 113-47t47-113q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47Zm0-80q-33 0-56.5-23.5T400-360q0-33 23.5-56.5T480-440q33 0 56.5 23.5T560-360q0 33-23.5 56.5T480-280ZM280-800v640-640Z"
            />
          </svg>
        </a>
        &nbsp;
        <a @click="headerActionClick('userDetail-sheet')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="currentColor"
          >
            <path
              d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
            />
          </svg>
        </a>
      </div>
    </div>
    <div class="header-item header-item-size" style="width: 30%" v-else></div>
  </div>
  <div
    style="
      width: 20px;
      height: 20px;
      z-index: 1000;
      position: fixed;
      top: 49px;
      left: -1px;
    "
  >
    <img
      :src="require('@/assets/header_left.webp')"
      style="width: 20px; height: 20px; border-radius: 0"
    />
  </div>
  <div
    style="
      width: 20px;
      height: 20px;
      z-index: 1000;
      position: fixed;
      top: 49px;
      right: -1px;
    "
  >
    <img
      :src="require('@/assets/header_right.webp')"
      style="width: 20px; height: 20px; border-radius: 0"
    />
  </div>
</template>

<script>
import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { db, auth, storage } from "./../plugins/firebase";
import { onAuthStateChanged } from "firebase/auth";
import {
  doc,
  getDoc,
  getDocs,
  query,
  collection,
  deleteDoc,
  updateDoc,
  arrayRemove,
  onSnapshot,
} from "firebase/firestore";
import {
  store,
  setUser,
  setUserIconUrl,
  removeUserIconUrl,
  removeAll,
  setLastLognAt,
} from "./../plugins/store";

export default {
  data() {
    return {
      user: {},
      imageUrl: null,
      isIcon: false,
      isBack: false,
      pageTitle: "",
      actionsType: "",
      infoCount: 0,
      unsubscribe: null,
    };
  },
  /**
   * type
   * search
   * info
   * celendar
   * user
   */
  props: ["is_icon", "is_back", "title", "type"],
  created() {
    this.user = store.user;
    this.isIcon = this.is_icon;
    this.isBack = this.is_back;
    this.pageTitle = this.title;
    this.actionsType = this.type;

    // ログイン情報チェック
    if (store.isAuth == false) {
      // ログイン情報取得
      onAuthStateChanged(auth, async (user) => {
        if (user == null) {
          // storeリセットしてトップページへ
          removeAll();
          this.$router.push("/");
        } else {
          const docRef = doc(db, "authLink", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const docUserRef = doc(db, "users", docSnap.data().uid);
            const docUserSnap = await getDoc(docUserRef);

            setUser(docUserSnap.data(), docSnap.data().uid);
          }
        }
      });
    }
    //リセット
    this.resetCount();
  },
  mounted() {
    if (this.user.isIconUrl) {
      if (store.userIconUrl == "") {
        this.getUserIcon();
      } else {
        this.imageUrl = store.userIconUrl;
      }
    }
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    const userRef = doc(db, "users", this.user.uid);
    this.unsubscribe = onSnapshot(userRef, (docSnap) => {
      if (docSnap.exists()) {
        this.user = docSnap.data();
        setUser(this.user, this.user.uid);
        const isLoad =
          this.user.isHeaderBadges == undefined
            ? false
            : this.user.isHeaderBadges;
        this.infoCount = isLoad ? 1 : 0;
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    /**
     * 1日1回だけ実行させる場所
     */
    async resetCount() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      if (store.lastLoginDate == undefined) {
        setLastLognAt(yesterday);
      }

      const loginUserRef = doc(db, "users", this.user.uid);

      const utcDate = new Date(store.lastLoginDate);
      if (utcDate > yesterday) {
        return;
      } else {
        console.log("reset");
        const docUserSnap = await getDoc(loginUserRef);
        this.user = docUserSnap.data();
        setUser(this.user, this.user.uid);

        setLastLognAt(today);

        /// いいね回数チェック
        const threeWeeksInMilliseconds = 21 * 24 * 60 * 60 * 1000; // 21日をミリ秒に変換

        // 自分がいいねした場合
        const queryLiked = query(
          collection(db, `users/${this.user.uid}/likedUsers`),
        );
        const queryLikedSnapshot = await getDocs(queryLiked);

        const liked = queryLikedSnapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));

        for (var i in liked) {
          const timestampDate = new Date(liked[i].data.likeAt.seconds * 1000);

          if (
            now.getTime() - timestampDate.getTime() >
            threeWeeksInMilliseconds
          ) {
            // 自分
            const docRef1 = doc(
              db,
              "users",
              this.user.uid,
              "likedUsers",
              liked[i].data.uid,
            );
            await deleteDoc(docRef1);
            await updateDoc(loginUserRef, {
              likedUID: arrayRemove(liked[i].data.uid),
            });
            // 相手
            const docRef2 = doc(
              db,
              "users",
              liked[i].data.uid,
              "likeUsers",
              this.user.uid,
            );
            await deleteDoc(docRef2);

            const likedUSerRef = doc(db, "users", liked[i].data.uid);
            await updateDoc(likedUSerRef, {
              likeUID: arrayRemove(this.user.uid),
            });
          }
        }

        // 自分がいいねされた場合
        const queryLike = query(
          collection(db, `users/${this.user.uid}/likeUsers`),
        );
        const queryLikeSnapshot = await getDocs(queryLike);

        const like = queryLikeSnapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));

        for (var n in like) {
          const timestampDate = new Date(like[n].data.likeAt.seconds * 1000);

          if (
            now.getTime() - timestampDate.getTime() >
            threeWeeksInMilliseconds
          ) {
            // 自分
            const docRef3 = doc(
              db,
              "users",
              this.user.uid,
              "likeUsers",
              like[n].data.uid,
            );
            await deleteDoc(docRef3);
            await updateDoc(loginUserRef, {
              likeUID: arrayRemove(like[n].data.uid),
            });
            // 相手
            const docRef4 = doc(
              db,
              "users",
              like[n].data.uid,
              "likedUsers",
              this.user.uid,
            );
            await deleteDoc(docRef4);

            const likeUSerRef = doc(db, "users", like[n].data.uid);
            await updateDoc(likeUSerRef, {
              likedUID: arrayRemove(this.user.uid),
            });
          }
        }
        /**
         * いいね回数回復、マッチング回数回復、レコメンド回復
         * いいね回数は女性もしくは課金なら10回でフリーは3回
         * マッチングは1回か無制限なのでbool
         * レコメンドは女性用だけど一緒くたに更新
         */
        await updateDoc(loginUserRef, {
          //いいね回数回復
          lastGoodAt: new Date(),
          maxGoodCount:
            this.user.isSubscription || this.user.sex == "女性" ? 10 : 1,
          //マッチング回数回復
          lastReplyGoodAt: new Date(),
          isReplyGood: true,
          //レコメンド
          lastRecommendAt: now,
          recommendCount: 5,
        });
      }

      const lastLoginAt = new Date();
      this.user.loginAt = lastLoginAt;
      setUser(this.user, this.user.uid);
      await updateDoc(loginUserRef, {
        loginAt: lastLoginAt,
      });
    },
    async getUserIcon() {
      const imageRef = storageRef(
        storage,
        `users/icon/${store.uid}/user_icon1.png`,
      );

      try {
        const url = await getDownloadURL(imageRef);
        this.imageUrl = url;
        setUserIconUrl(url);
      } catch (error) {
        console.log("---------- components/headerView ---------");
        console.error("Error fetching image URL:", error);
      }
    },
    handleBeforeUnload(event) {
      // eslint-disable-next-line no-unused-vars
      event = null;
      removeUserIconUrl();
    },
    headerActionClick(t) {
      this.$emit("header-action-click", t);
    },
  },
};
</script>

<style scoped>
a {
  color: #fff;
}
img {
  width: 35px;
  height: 35px;
  object-fit: cover;
  border-radius: 50%;
}
.icon {
  color: #fff;
  font-size: 30px;
}
.header-item {
  float: left;
}
.header-item-size {
  padding-top: 14px;
  padding-left: 8px;
  padding-right: 8px;
}
.title {
  color: #fff;
  font-size: 30px;
}

.header-back {
  position: fixed;
  top: 0;
  width: 100%;
  height: 55px;
  background: -moz-linear-gradient(-135deg, #8a49a1, #784ba0, #6d54a6);
  background: -webkit-linear-gradient(-135deg, #8a49a1, #784ba0, #6d54a6);
  background: linear-gradient(-135deg, #8a49a1, #784ba0, #6d54a6);
  background-color: #784ba0;
  z-index: 999;
}
</style>
